/*
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function RenderPdf(doc){
  pdfMake.createPdf(doc).download();
}*/
//parse data string (base64) into a downloadable pdf file
function RenderPdf(dataString,elementID){
  //download the consent form as a pdf
  let hiddenElement = document.getElementById(elementID);
  hiddenElement.href = 'data:application/pdf;base64,' + encodeURI(dataString);
  hiddenElement.target = '_blank';
  hiddenElement.download = 'ConsentForm.pdf';//add timestamp
  hiddenElement.click();
}
export default RenderPdf
